import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-1 flex flex-col" }
const _hoisted_2 = { class: "flex flex-row items-center gap-1 gordita-400-13 text-Text/text_medium" }
const _hoisted_3 = { class: "gordita-400-12 max-w-[256px] break-all" }
const _hoisted_4 = { class: "flex flex-col grow w-full place-content-between" }
const _hoisted_5 = {
  class: "gordita-medium-500-20",
  "data-testid": "distributed-percentage"
}
const _hoisted_6 = { class: "flex w-full" }
const _hoisted_7 = { class: "flex w-full place-content-between" }
const _hoisted_8 = {
  class: "gordita-400-13 text-Text/text_high",
  "data-testid": "cpu-distributed"
}
const _hoisted_9 = {
  class: "gordita-400-13 text-Text/text_low",
  "data-testid": "cpu-total"
}
const _hoisted_10 = { class: "flex-1 pl-4 flex flex-col border-l border-l-System/app_border" }
const _hoisted_11 = { class: "flex flex-row items-center gap-1 gordita-400-13 text-Text/text_medium" }
const _hoisted_12 = { class: "gordita-400-12 max-w-[256px] break-all" }
const _hoisted_13 = { class: "flex flex-col grow w-full place-content-between" }
const _hoisted_14 = {
  class: "gordita-medium-500-20",
  "data-testid": "unmet-helper-requests"
}
const _hoisted_15 = { class: "flex w-full" }
const _hoisted_16 = { class: "flex-1 pl-4 flex flex-col gap-4 border-l border-l-System/app_border" }
const _hoisted_17 = { class: "flex flex-row gap-1 gordita-400-13 text-Text/text_medium" }
const _hoisted_18 = { class: "flex-1 pl-4 flex flex-col gap-4 border-l border-l-System/app_border" }
const _hoisted_19 = { class: "flex flex-row gap-1 gordita-400-13 text-Text/text_medium" }

import { ref } from 'vue';
import { Maybe } from 'graphql/jsutils/Maybe';
import { IncrediTooltip, IncrediProgressBar } from 'incredi-ui';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import COLORS from '@/design-system/colors.json';
import { convertBaseTimeToSSMMHH } from '@/views/dashboard/dashboard.charts.utils';
import WorkloadViewPerformanceBarChart from './workload-view-performance-bar-chart.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-performance-build-helpers-distribution',
  props: {
    cpuTime: null,
    shortfallPercentage: null,
    agents: null,
    cores: null
  },
  setup(__props: any) {

const cpuTimeRef = ref(false);
const unmetHelperRequests = ref(false);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "workload-view-performance-helpers-distribution flex flex-row gap-4 w-full" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.helperDistribution.cpuTime')), 1),
          _createVNode(_unref(IncrediTooltip), {
            modelValue: cpuTimeRef.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cpuTimeRef).value = $event)),
            hover: "",
            delay: 200
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.helperDistribution.cpuTimeTooltip')), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass(["text-[16px] text-Text/text_low", cpuTimeRef.value ? 'uis uis-info-circle' : 'uil uil-info-circle']),
                "data-testid": "workload-view-performance-helpers-distribution-cpu-time"
              }, null, 2)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.cpuTime.distributedPercentage || 0) + "% ", 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(convertBaseTimeToSSMMHH)(__props.cpuTime.distributed || 0) || _ctx.$t('generic.time.lessThanSecond')), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(convertBaseTimeToSSMMHH)(__props.cpuTime.total || 0)), 1)
            ]),
            _createVNode(_unref(IncrediProgressBar), {
              total: {
              value: __props.cpuTime.total || 0,
              color: _unref(COLORS)['System/app_grey_89'],
            },
              buffers: [
              {
                value: __props.cpuTime.distributed || 0,
                color: _unref(COLORS)['System/app_secondary'],
              },
            ]
            }, null, 8, ["total", "buffers"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.helperDistribution.unmetHelperRequests')), 1),
          _createVNode(_unref(IncrediTooltip), {
            modelValue: unmetHelperRequests.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((unmetHelperRequests).value = $event)),
            hover: "",
            delay: 200
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.helperDistribution.unmetHelperRequestsTooltip')), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass(["text-[16px] text-Text/text_low", unmetHelperRequests.value ? 'uis uis-info-circle' : 'uil uil-info-circle']),
                "data-testid": "workload-view-performance-helpers-distribution-cpu-time"
              }, null, 2)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(__props.shortfallPercentage || 0) + "% ", 1),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_unref(IncrediProgressBar), {
              total: {
              value: 100,
              color: _unref(COLORS)['System/app_grey_89'],
            },
              buffers: [
              {
                value: __props.shortfallPercentage || 0,
                color: _unref(COLORS)['System/app_secondary'],
              },
            ]
            }, null, 8, ["total", "buffers"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.helperDistribution.helperAgents')), 1)
        ]),
        _createVNode(WorkloadViewPerformanceBarChart, {
          "chart-id": "helperAgents",
          sections: [
          { title: _ctx.$t('workloads.details.performanceMetricsTab.helperDistribution.max'), value: __props.agents.max || 0, color: _unref(COLORS)['System/app_secondary'], dataTestId: 'max-agents' },
          { title: _ctx.$t('workloads.details.performanceMetricsTab.helperDistribution.avg'), value: __props.agents.avg || 0, color: _unref(COLORS)['Text/text_medium'], dataTestId: 'avg-agents' },
        ]
        }, null, 8, ["sections"])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.helperDistribution.helperCores')), 1)
        ]),
        _createVNode(WorkloadViewPerformanceBarChart, {
          "chart-id": "helperCores",
          sections: [
          { title: _ctx.$t('workloads.details.performanceMetricsTab.helperDistribution.max'), value: __props.cores.max || 0, color: _unref(COLORS)['System/app_secondary'], dataTestId: 'max-cores' },
          { title: _ctx.$t('workloads.details.performanceMetricsTab.helperDistribution.avg'), value: __props.cores.avg || 0, color: _unref(COLORS)['Text/text_medium'], dataTestId: 'avg-cores' },
        ]
        }, null, 8, ["sections"])
      ])
    ]),
    _: 1
  }))
}
}

})